import type { WidgetComponent } from "@viz/presentation";

const Header: WidgetComponent = ({ props, children }) => {
  const title = String(props.title ?? "");
  const subtitle = props.subtitle != null ? String(props.subtitle) : "";
  const accent = String(props.accent ?? "#0ea5e9");
  return (
    <header className="flex flex-col gap-1 border-b border-slate-200 bg-slate-50 px-5 py-3">
      <div className="flex items-center gap-3">
        <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: accent }} />
        <h1 className="text-base font-semibold text-slate-900">{title}</h1>
      </div>
      {subtitle && <div className="text-xs text-slate-600">{subtitle}</div>}
      {children}
    </header>
  );
};

export default Header;
